<template>
  <div class="view">
    <Loading v-if="this.loading" />
    <Modal
      v-if="showModal"
      @close-modal="closeModal"
      :modalMessage="modalMessage"
    />
    <div class="container" v-if="!this.loading">
      <h1>Summary</h1>
      <div class="order">
        <div class="order-details">
          <p>
            Location To Be Delivered To:
          </p>
          <b>{{ orderDetails.userLocation }}</b>
          <p>
            Restaurant:
          </p>
          <b>{{ orderDetails.restaurantName }}</b>
          <p>
            Location Of The Restaurant:
          </p>
          <b>{{ orderDetails.restaurantLocation }}</b>
          <p>
            Time:
            <!-- <b>before {{orderDetails.deliveryTime}}</b> -->
          </p>
          <b>Before {{ deadline }}</b>
        </div>
        <div class="order-items">
          <h6>Food To Be Delivered:</h6>
          <OrderSummaryItemView
            v-for="(food, index) in orderDetails.foodItems"
            :key="food"
            :itemName="food"
            :itemQuantity="orderDetails.foodItemsQuantity[index]"
          />
          <h6>Additional Requests:</h6>
          <p>{{ orderDetails.additionalRequests }}</p>
          <!--
          <table border="1px">
            <thead>
              <tr>
                <th class="tg-0lax">No.</th>
                <th>Food</th>
                <th>Quantity</th>
                <th class="tg-0lax">Remark</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(food, index) in orderDetails.foodItems" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ food }}</td>
                <td>{{ orderDetails.foodItemsQuantity[index] }}</td>
                <td>{{ orderDetails.foodItemsRemarks[index] }}</td>
              </tr>
            </tbody>
          </table>
          -->
        </div>
      </div>
      <div class="order-conditions">
        <p>
          You Have About 40 Minutes To Save The Savour Of The Customer! <br />
          Make Sure You Can Make It In Time Before You Accept This Order!
        </p>
        <input v-model="agreement" type="checkbox" name="terms" /> I Agree To
        The
        <router-link :to="{ name: 'SaviourTermsAndConditions' }"
          >Terms & Coditions</router-link
        >
        And Will Deliver The Food In 40 Minutes.
        <div class="buttons">
          <button @click="back">Back</button>
          <button @click.prevent="accepted" name="acceptBtn">
            Accept The Order
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from "../firebase/firebaseInit";
import Loading from "../components/Loading.vue";
import OrderSummaryItemView from "../components/OrderSummaryItemView";
import Modal from "../components/Modal.vue";

export default {
  name: "ConfirmAndAccept",
  components: {
    Loading,
    OrderSummaryItemView,
    Modal,
  },
  props: ["orderId"],
  data() {
    return {
      orderDetails: [],
      acceptedTerms: false,
      agreement: false,
      loading: true,
      modalMessage: "Sorry, The Order Has Been Accepted Or Cancelled!",
      showModal: false,
    };
  },
  async created() {
    var docRef = await db.collection("orders").doc(this.orderId);
    await docRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          console.log("Document data OK:", doc.data());
          this.orderDetails = doc.data();
          this.deadline = this.orderDetails.time.toDate();
          this.loading = false;
          console.log("after fetching orderDetails ->", this.orderDetails);
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document! 1");
        }
      })
      .catch((error) => {
        console.log("Error getting document:", error);
      });
    this.loading = false;
  },
  mounted() {
    // this.orderDetails = this.$store.getters.getSpecificOrder;
    /* Try to fix the refresh data gone problem
    console.log("StateOrders:", this.$store.state.orders);
    this.orderDetails = this.$store.state.orders.find((order) => {
      console.log("inside Find: ", order);
      return order.orderId == this.orderId;
    });*/
  },

  // mounted() {
  //   this.orderDetails = this.$route.params.orderDetails;
  //   console.log(this.orderDetails);
  // },
  methods: {
    back() {
      this.$router.push({
        name: "FetchOrder",
      });
    },
    closeModal() {
      this.showModal = false;
      this.back();
    },
    async accepted() {
      if (!this.agreement) {
        //window.alert("Please Accept The Terms&Condition");
        this.$toast.warning("Please Accept The Terms & Conditions!");
        return;
      }

      const check = await db.collection("orders").doc(this.orderId);
      const checkResults = await check.get();

      if (
        checkResults.data().acceptedBySaviour ||
        checkResults.data().cancelled
      ) {
        this.showModal = true;
        return;
      }
      //UPDATE the details after accepting the order
      var timeToUpdate = new Date(new Date().getTime() + 40 * 60000);
      console.log("timeToUpdate =>", timeToUpdate);
      await db
        .collection("orders")
        .doc(this.orderId)
        .update({
          acceptedBySaviour: true,
          saviourContact: this.$store.state.profilePhoneNumber,
          saviourName: this.$store.state.profileFirstName,
          deliveryTime: timeToUpdate,
        });
      var userRef = await db
        .collection("users")
        .doc(this.$store.state.profileId);
      // Update the user fields "delivering" to True and "delivering Id" to the current orderId
      await userRef
        .update({
          delivering: true,
          deliveringId: this.orderId,
        })
        .then(() => {
          console.log("Order successfully updated to user!!");
        })
        .catch((error) => {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
      this.$router.push({
        name: "Confirmed",
        params: {
          orderDetails: this.orderDetails,
          orderId: this.orderId,
        },
      });
    },
  },
  computed: {
    deadlineDate() {
      var add40Minutes = 40;
      return new Date(new Date().getTime() + add40Minutes * 60000);
    },
    deadline() {
      var add40Minutes = 40;
      var result = new Date(new Date().getTime() + add40Minutes * 60000);
      function setampm(hours) {
        if (hours < 12) {
          return "AM";
        }
        return "PM";
      }
      var ampm = setampm(result.getHours());
      var hour =
        result.getHours() < 10 ? "0" + result.getHours() : result.getHours();
      var minute =
        result.getMinutes() < 10
          ? "0" + result.getMinutes()
          : result.getMinutes();
      return hour + ":" + minute + ampm;
    },
  },
};
</script>

<style lang="scss" scoped>
.view {
  display: flex;
  justify-content: center;

  .container {
    display: flex;
    flex-direction: column;
    //align-items: center;
    margin: 0 20px;

    h1 {
      font-family: "Quicksand", "sans-serif";
      text-align: center;
      margin-bottom: 10px;
    }

    .order {
      flex-basis: 80%;

      display: flex;
      flex-direction: column;

      @media (min-width: 800px) {
        flex-direction: row;
        justify-content: space-around;
        gap: 50px;
      }

      .order-details {
        min-width: 30vw;
        display: block;
        background-color: #f1f1f1;
        padding: 20px 20px;
        border-radius: 8px;
        text-align: center;

        @media (min-width: 800px) {
          text-align: left;
        }

        p {
          margin-top: 10px;
          font-size: 1.4em;
        }

        b {
          font-family: "Quicksand", sans-serif;
          font-size: 1.4em;
        }
      }

      .order-items {
        min-width: 30vw;
        //background-color: #f1f1f1;
        background: rgba(0, 0, 0, 0.5);
        padding: 20px 20px;
        border-radius: 8px;
        //align-self: center;
        margin-top: 10px;

        p {
          text-align: center;
          color: #fff;
          font-size: 16px;
        }

        @media (min-width: 800px) {
          margin-top: 0px;
        }

        h6 {
          margin-top: 5px;
          margin-bottom: 0;
          color: #fff;
          font-size: 20px;
          text-align: center;
        }
      }
    }

    .order-conditions {
      margin: 10px 0;
      flex-basis: 20%;
      text-align: center;
      font-size: 1.4em;

      .buttons {
        display: flex;
        justify-content: space-evenly;

        button:hover {
          cursor: pointer;
          background-color: rgb(50, 50, 50);
          transition: 0.25s;
        }
      }
    }
  }
}
/*
p {
  font-family: "Quicksand", sans-serif;
  font-size: 1.4em;
  margin-top: 10px;
}
*/
</style>
